import http from "./httpService";
import { openPdf } from "../utils/downloadPdf";

const apiEndpoint = "/client/invoices";

export function getInvoices(params = {}) {
  return http.get(apiEndpoint, { params });
}

export function getInvoice(id) {
  return http.get(`${apiEndpoint}/${id}`);
}

export function startInvoicePayment(invoiceId, body = {}) {
  return http.post(`${apiEndpoint}/${invoiceId}/pay`, body);
}

export function allocateInvoiceCredit(invoiceId, body = {}) {
  return http.post(`${apiEndpoint}/${invoiceId}/allocate-credit`, body);
}

export function downloadInvoicePdf(id, filename) {
  return openPdf(`${apiEndpoint}/${id}/pdf`, filename);
}

export function downloadReceiptPdf(transid, filename) {
  return openPdf(`/client/payment/${transid}/pdf`, filename);
}
